//备注：为保证文档可维护性 翻译时 请注意以下事项：
// 1。请按照该文件的格式翻译，只翻译中文部分
// 2。所有的标点符号按照原样保留
// 3。空格需按照原样保留
// 4。举例说明：
// 辛苦翻译！
export const m = {
  "common": {
    "delete": "delete",
    "edit": "edit",
    "more": "more",
    "sure": "enter",
    "cancle": "cancel",
    "submit": "submit",
    "add": "add",
    "companyName": "company name",
    "mail": "mail",
    "tel": "cellphone",
    "telPhone": "cellphone number",
    "phone": "telephone",
    "optional": "optional",
    "position": "occupation",
    "industry": "industry",
    "channel": "channel",
    "name": "name",
    "userName": "username",
    "nickName": "nickname",
    "save": "save",
    "prompt": "prompt",
    "all": "all",
    "operate": "operate",
    "back": "back",
    "close": "close",
    "number": "number",
    "create_time": "create time",
    "content": "content",
    "status": "status",
    "success": "success",
    "fail": "fail",
    "fresh": "refresh",
    "remove": "remove",
    "send": "send",
    "count": "count",
    "time": "time",
    "date": "date",
    "import": "import",
    "export": "export",
    "detail": "Check details",
    "to": "To",
    "start_time": "Start date",
    "end_time": "Ending date",
    "choosed": "Already selected",
    "choose_count": "(Number of information)",
    "please": "Please",
    "show_video": "Click to see the usage video",
    "open": "Open",
    "page": "Number of the records per page",
    "page_holder": "Please select the page number"
  },
  "mail_err": "Please enter the correct mailbox!",
  "telPhone_empty": "Telephone number should not be empty!",
  "tel_empty": "cellphone number should not be empty!",
  "tel_err": "Please enter the correct cellphone number!",
  "pass_empty": "Password should not be empty!",
  "pass_err": "Password must be 6 to 15 characters!",
  "feedBackContent_empty": "Please enter the feedback!",
  "company_length": "Company name should not exceed 80 words",
  "company_address_length": "Company address information must not exceed 80 words",
  "checkbox_choose_one": "Please select at least one item to delete!",
  "file_empty": "Please select the file to import!",
  "only_support": "Only support the following file format:",
  "no_support": "We Can’t support this file format",
  "cancle_delete": "cancel",
  "delete_succ": "Deleted",
  "add_succ": "Added",
  "edit_succ": "Edited",
  "clear_succ": "Cleared",
  "post_succ": "Submitted",
  "set_succ": "Set up successfully",
  "batch_operate": "Batch operate",
  "batch_import": "Batch import",
  "batch_deal": "Batch process",
  "all_export": "Export all",
  "bacth_export": "Batch export",
  "batch_delete": "Batch delete",
  "import_err": "Failed to import",
  "import_progress": "Import progress",
  "importing": "Importing",
  "customerService": "Intelligence Customer Service",
  "robot": "Robot",
  "platform": "Chatroom",
  "globalSetting": "Settings",
  "userInfo": "User Info",
  "feedBack": "Feedback",
  "feedBackContent": "Feedback content",
  "loginOut": "Logout",
  "help": "Help",
  "user": "User",
  "paradigm": "4th Paradigm",
  "videoCourse": "Video introduction",
  "operateGuide": "Operation guide",
  "issueConsult": "Contact us",
  "newuserGuide": "Beginner Guides",
  "newuserGuide_step": {
    "newuserGuide_error": " You are in the beginner guides…",
    "start": "Start from here, give me more abilities~",
    "know": "I know",
    "complete_info": "Dear friend, please complete your information",
    "complete_info_s": "Perfect information successfully",
    "complete_info_f": "Perfect information failed, reason is ",
    "know_channel": "How to know us",
    "rule_start": "Hi, friend, help me acquire the Q&A ability~",
    "have_start": "After opening this skill, when visitors consult questions, I can answer questions by following the rules of the host configuration instead of the host!",
    "pass": "Pass",
    "enter_course": "Enter guides",
    "use_channel_err": "Please select at least one intentional usage channel"
  },
  "contactUs": "Contact us",
  "contact_us": {
    "text1": "Scan QR code and follow the Wechat subscription",
    "text2": "添加微信号18501331225咨询"
  },
  "ics_support": "Technology support",
  "system": {
    "over_course": "Finish the guide",
    "finish": "Finish",
    "step1": "Step 1: Click \"Add Q&A” in the upper right corner of the page to enter the Q&A adding page",
    "step2": "Step 2: Enter the questions that users may ask in the \"Standard Question\" section, such as \"When will the books be delivered\". Enter the answers to the questions in the \"Answer Content\". For example, \"General logistics can be delivered 3-5 days after delivery, and you can call 123456 whenever you have questions.\"  Click OK. You can also try to configure other types of answers",
    "step3": "Step 3: Click on the “Demo Robot\" in the bottom left corner of the page and enter the questions just set, such as \"When will the book be delivered?\" I will answer the answers just configured",
    "step4": "Step 4: Select one or more channel to access the robot"
  },
  "list": {
    "setRobot": "Settings",
    "baseInfo": "Robot informaition",
    "visitor": "Visitors",
    "CVS": "Conversations",
    "CVSMSG": "Messages",
    "rules": "Knowledge rules",
    "channel": "Channels",
    "addRobot": "Add robot",
    "robotName": "Robot name",
    "change_robotName": "Change a new name",
    "add_err": "Please enter a valid name!",
    "sure_delete": "Determine to delete the robot?(BE CAREFUL to do this operation！)",
    "delete_succ": "Deleted",
    "language": "Language",
    "english": "English",
    "chinese": "Chiniese"
  },
  "channelList": {
    "WEB": "WEB",
    "WECHAT": "Wechat Subscription",
    "APP": "APP",
    "WEIBO": "Weibo",
    "WECHAT_CP": "Enterprise Wechat",
    "WECHAT_PER": "Personal Wechat",
    "WECHAT_MINI_PROGRAM": "Wechat Applications",
    "ANDROID": "Android",
    "IOS": "IOS",
    "CHAT": "Wechat",
    "OTHER": "Others",
    "Android": "Android",
    "API": "API",
    "WECHAT_MINI_PLUGIN": "Wechat applet plug-in",
    "WECHAT_PER_GROUP": "WeChat assistant"
  },
  "dateList": {
    "week": "Last week",
    "month": "Last month",
    "three_month": "Last three months"
  },
  "userInfoInner": {
    "personInfo": "PersonalInfo",
    "personInfo_succ": "Modified!",
    "personInfo_err": "Failed to modify!",
    "bingPhoneInfo": "Bind cellphone",
    "bingPhoneInfo_succ": "Bind mobile phone number successfully",
    "changePhoneInfo": "Modify mobile phone number",
    "changePhoneInfo_succ": "Modify mobile phone number successfully",
    "bindPhone": {
      "tel": "Cellphone number",
      "imageCode": "Verification code",
      "imageCode_empty": "You should enter the graphic verification code",
      "verifyCode": "Phone verification node",
      "verifyCode_empty": "You should enter the phone verification code!",
      "refresh": "Click to refresh"
    },
    "companyInfo": "Company information",
    "companyInfo_succ": "Modified!",
    "companyInfo_err": "Failed to modify!",
    "company": {
      "name": "Company name",
      "address": "Company address",
      "mail": "Company email",
      "tel": "Company telephone"
    },
    "passwordInfo": "Change password",
    "passwordInfo_succ": "Changed!",
    "passwordInfo_err": "Failed to change password!",
    "password": {
      "old": "Old password",
      "new": "New password"
    },
    "getCode": "Get CAPTCHA",
    "haveSend": "Have sent",
    "second": "Second"
  },
  "robot_left": {
    "tab": "Shift",
    "rule_manage": "Knowledge Base",
    "rules": "Q&A rules",
    "words": "Dictionary",
    "unknowQ": "Unidentified Question",
    "material": "Material management",
    "base_set": "Basic settings",
    "robotInfo": "Robot information",
    "autoQA": "Automatic answer",
    "sdk": "Channels",
    "data_statistics": "Statistics",
    "history_con": "Past conversation",
    "reception_set": "Service settings",
    "experience_robot": "Demo Robot"
  },
  "rules": {
    "add_rules": "Add rules",
    "clear_rules": "Clear rules",
    "category": "Category",
    "default_category": "Default category",
    "category_holder": "Enter the category name",
    "rules_status": "Rule status",
    "choose": "Choose",
    "serch_rule_holder": "Search Q&A rules",
    "np_rules": "There is no Q&A rule yet",
    "please_add": "Please add a Q&A rule",
    "conversion": "Conversation",
    "can_use": "Good",
    "cant_use": "Bad",
    "use_rate": "Good answer rate",
    "question": "Question",
    "have_stop": "Stopped",
    "have_active": "Actived",
    "wait_communicate": "Reviewing",
    "answer": "Answer",
    "authed": "Reviewed",
    "active": "Active",
    "stop": "Stop",
    "review": "Browse",
    "importing_text": "Waiting for the importing~",
    "import_err_text": "Failed to import all the rules, click to find the problems",
    "import_log": "Import log",
    "import_log_text": "You can modify the file according to the log, then continue importing",
    "checking": "Reviewing",
    "opearte_info": "Operation tips",
    "have_editing": "Some options are being edited and added",
    "delete_sure": "Are you sure to delete this category?",
    "categoryName_empty": "Category name shouldn’t be empty",
    "delete_rules_sure": "Are you sure to delete the rule?",
    "delete_choose_rules": "Are you sure to delete all the selected rules?",
    "clear_rules_sure": "Are you sure to clear all the rules?",
    "err_log": "Error log",
    "no_err_log": "No error log yet"
  },
  "add_rules": {
    "star_question": "Standard question",
    "star_holder": "The most common questioning method visitors may ask",
    "simi_question": "Similiar question",
    "simi_holder": "The other questioning method visitors may ask，Input more questioning method would be more accuracy",
    "add_simi": "Add similiar question",
    "star_empty": "Standard question shouldn’t be empty!",
    "simi_empty": "Similiar question shouldn’t be empty!",
    "star_simi_empty": "Standard or similiar question shouldn’t be empty!",
    "str_err": "Similiar question is duplicated!",
    "star_data_err": "This standard question is same with some question in data base, please input again!",
    "star_simi_err": "This standard question is same with some similiar question, please input again!",
    "simi_simi_err": "This similiar question is same with other similiar question, please input again!",
    "simi_star_err": "This similiar question is same with some standard question, please input again!",
    "simi_data_err": "This similiar question is same with some question in data base, please input again",
    "simi_empty_err": "Similiar question is duplicated or empty!",
    "answer_empty": "Please fill in or select answer content!",
    "post_succ1": "Have been submitted! Waiting for the admin to review it!",
    "post_succ2": "Have been added in knowledge base!",
    "rich_text": {
      "title": "Title shouldn’t be empty!",
      "content": "Content shouldn;t be empty!",
      "cover": "Cover shouldn’t be empty!",
      "digest": "Digest shouldn’t be empty!"
    },
    "相似问法推荐": "Similar questioning method recommendation",
    "匹配模式": "Match pattern",
    "语义匹配": "Semantic matching",
    "精确匹配": "Exact matching",
    "加为相似问题": "Add as similar question",
    "推荐问题": "Recommended question",
    "不能选择与问答库中已有问题重复的问法": "Cannot choose the repeated questioning method which is already existed in the Q&A pack",
    "暂无相似问法推荐": "No recommendation for similar questioning method at present",
    "成功添加问答规则": "Add Q&A rule successfully"
  },
  "page": {
    "goto": "Go",
    "pageSize": "Page"
  },
  "table": {
    "level_menu_one": "First class menu item",
    "one_level": "First class menu"
  },
  "import": {
    "step1": "Step 1",
    "step2": "Step 2",
    "down": "Download",
    "wechat_template": "Wechat_Template",
    "rule_template": "Rule_Template",
    "word_template": "Dictionary_Template",
    "word_file": "Upload the file after editing",
    "rule_file": "Upload the file after editing",
    "wechat_file": "Upload the file after editing",
    "upload_err": "Uploading may be faied in the following conditions:",
    "import_introduce": "Importing attentions:",
    "word_text1": "Not importing with standard template",
    "word_text2": "Dictionary name exceeds 255 characters. Word exceeds 50 characters",
    "word_text3": "There are duplicated words/homoionyms in one dictionary",
    "rule_text1": "Not importing with standard template",
    "rule_text2": "Question or answer column is empty",
    "rule_text3": "Standard/similiar question exceeds 80 words, answer exceeds 2000 words",
    "rule_text4": "There’re duplicated standard/similiar questions in the excel and knowledge base",
    "wechat_text1": "It shouldn’t be imported over 100,000 keywords once",
    "wechat_text2": "A keyword shouldn’t exceed 20 characters",
    "wechat_text3": "Shouldn’t import duplicated keywords in one wechat subscripton",
    "wechat_text4": "Every keywords must be with corresponding wechat subscription and matching method"
  },
  "upload": {
    "answer_type": "Answer type",
    "answer_content": "Answer content",
    "text": "Text",
    "image": "Image",
    "audio": "Audio",
    "menu": "Menu",
    "rich_text": "Image-text"
  },
  "upload_type": {
    "answer_holder": "Please enter answer content",
    "upload": "Upload",
    "drop_text": "Drag your data file here to upload",
    "or": "or",
    "click_upload": "Click here",
    "modify": "Modify",
    "material": "Material base",
    "choose_material": "Select from Material base",
    "re_choose": "Change another one",
    "save_material": "Save to material base",
    "view_rich_text": "Preview",
    "choose_send_method": "Choose the way to send the image-text:",
    "choose_method1": "Image-text card",
    "choose_method1_info": "The edited image-text answers are sent to the visitors in the form of Image-text cards. After clicking, the visitors jump to the new page to view the content",
    "choose_method2": "Rich text",
    "choose_method2_info": "Edited image-text answers are sent directly to visitors in the form of rich text, but if the answers contain pictures, they will be sent automatically in the form of graphic cards in Weichat&Weibo channel",
    "search": "Search",
    "no_material": "Can’t find qualified material",
    "pause": "Pause",
    "audio_limit": "Audio size limit: 2M!",
    "image_limit": "Image size limit: 2M!",
    "my": "Mine"
  },
  "rich_text": {
    "notice": "Attention: Personal Wechat Can’t support image-text message",
    "holder": "Please enter image-text content",
    "title": "Title",
    "content": "Content",
    "cover": "Cover",
    "cover_limit": "Cover image should be limited in 900px*500px",
    "digest": "Digest",
    "auto_get": "Former 54 words of the article will be get as digest. Click",
    "here": "Here",
    "get": "to get",
    "local_upload": "Upload locally",
    "cover_err": "Cover image should be limited in 900px*500px!",
    "link_err": "Please select the text before adding the link!"
  },
  "word": {
    "add_words": "Add dictionary",
    "clear_words": "Clear dictionary",
    "search_words": "Search",
    "no_words": "No dictionary yet",
    "name": "Dictionary name",
    "importing_word": "Waiting for importing dictionaries…",
    "delete_sure": "Are you sure to delete the dictionary?",
    "clear_sure": "Are you sure to clear all the dictionaries?",
    "delete_choose_sure": "Are you sure to delete all selected dictionaries?"
  },
  "edit_word": {
    "edit": "Edit dictionary",
    "search": "Search",
    "add": "Add words",
    "word": "Word",
    "simi_word": "homoionym",
    "delete_sure": "Are you sure to delete the word？"
  },
  "unknow": {
    "question": "Unidentified question",
    "notice": "In accordance with frequency to statistics the questions of robot cannot answer,  this can add high frequency unknown questions into the repository",
    "questionInner": {
      "search": "Search",
      "clear": "Clear",
      "qus": "quetion",
      "fre": "Frequency",
      "time": "Time",
      "add": "Add to rules",
      "no": "No unidentified question yet",
      "add_succ": "Successfully added!",
      "delete_sure": "Are you sure to delete ",
      "delete_batch": "Are you sure to delete all selected questions?",
      "delete_all": "Are you sure to clear all the questions?",
      "que_detail": "Question detail"
    },
    "cluster": "Undefined question cluster",
    "clusterInner": {
      "detail": "Detail",
      "look_detail": "More details",
      "no": "No cluster yet"
    },
    "rule": "Rule based classifying",
    "sta": "Standard question (within 80 words)",
    "simi1": "Similar questioning method 1",
    "simi2": "Similar questioning method 2",
    "simi3": "Similar questioning method 3",
    "simi4": "Similar questioning method 4",
    "answer": "Answer (within 2000 words)"
  },
  "material": {
    "rich_text": "Image-text",
    "no_rich": "No image-text material",
    "no_image": "No image material",
    "no_audio": "No audio material",
    "no_menu": "No menu material",
    "add_menu": "Add menu",
    "menu_name": "Menu name",
    "menu_empty": "Please enter menu name!",
    "menu_succ": "Successfully added menu!",
    "delete_sure": "Are you sure to delete the material?",
    "total": "Totally upload",
    "file": "files",
    "file_succ": "Successfully uploaded",
    "file_err": "Failed to upload",
    "file_reason": "Reasons"
  },
  "menu": {
    "content": "Content",
    "change": "Modify",
    "level": "Class",
    "add_menu": "Add menu item",
    "view_image": "View"
  },
  "robot_info": {
    "技能管理": "Skills management",
    "head": "Robot avatar",
    "own_set": "Customize",
    "set_default": "Default",
    "name": "Robot nickname",
    "username_empty": "Please enter username",
    "service": "Service management",
    "custom": "Customize",
    "own_chat": "Customize chat",
    "chat_style": "Customize your desired chat style",
    "custom_finish": "Done! You can",
    "re_custom": "customize again",
    "custom_own_chat": "Customize chat",
    "chat_template": "You have to upload at least 20,000 Q&A txt files to customize your custom chat",
    "yuliao_template": "Chat template",
    "finish_upload": "Upload chat files after editing",
    "choose_file": "Select a file",
    "only_txt": "Only .txt files can be uploaded",
    "free_chat": "Daily chat",
    "free_chat_msg": "This service can be active only in Chinese mode",
    "logistics": "Logistics query",
    "logistics_msg": "This service can be active only in Chinese mode",
    "couplet": "Automatic couplets",
    "couplet_msg": "This service can be active only in Chinese mode",
    "poetry": "Automatic poetry",
    "poetry_msg": "This service can be active only in Chinese mode",
    "kg": "Knowledge inquiry",
    "kb_msg": "This service can be active only in Chinese mode",
    "start_train": "Start training",
    "name_succ": "Successfully modify the nickname!",
    "choose_image": "Please select an image file!",
    "choose_txt": "Please select a .txt file！",
    "head_succ": "Successfully change the avatar!",
    "set_default_succ": "Successfully restore defaults!",
    "start_msg": "Training…It will spend 2 to 7 days to finish training"
  },
  "response": {
    "greeting": "Greetings",
    "default": "Default replies",
    "timeout": "Closing words",
    "start_greet": "Open greeting",
    "greet_sub": "When session starts, the system will automatically send welcomes to the visitor",
    "greet_list": "Greeting list",
    "add_greet": "Add greeeting",
    "no_greet": "No greeting yet",
    "delete_greet": "Are you sure to delete the greeting?",
    "default_list": "Default reply list",
    "add_default": "Add default reply",
    "no_default": "No default reply yet",
    "delete_default": "Are you sure to delete the default reply?",
    "reply_empty": "Reply shouldn’t be empty!",
    "reply_length_err": "Reply shouldn’t exceed 2000 words!",
    "over_time": "Conversation closing time",
    "minute": "minutes",
    "timeout_list": "Closing words list",
    "add_timeout": "Add Closing words",
    "no_timeout": "No Closing words yet",
    "delete_timeout": "Are you sure to delete the closing words?",
    "example": "Example shown as below picture",
    "open_overtime": "Open timeout reply",
    "overtime_sub": 'In the case of the visitor does not reply within a set time, the robot will reply an overtime hint to the visitor, such as "Are you still there ? " After triggering the overtime reply, if the visitor still does not reply, the session will be automatically closed.',
    "opne_unknow": "Open reply function of unknown question",
    "unknow_sub": "In the case of the robot cannot answer the visitors question, it will send a reply of the unknown question, such as 'Sorry, I dont know how to answer this question.Ill try to learn it.'",
    "guess": "Guess you want to ask",
    "guess_sub": "After open this function, it will be automatically generate a menu according to the Q&A pack and send to the visitor",
    "unknow_list": "Unknown question reply list",
    "add_unknow": "Add unknown question reply",
    "no_unknow": "No unknown question reply",
    "open_similar": "Open similar question guidance",
    "similar_sub": "In the case of the robot cannot find the best answer, it will recommend several possible similar questions, and will inquire the visitor whether to ask one of those questions",
    "guide_title": "Guide the title",
    "reply_way": "Reply mode",
    "reply_all": "Reply all",
    "reply_one": "Randomly reply one message",
    "not_greet": "No welcomes at present",
    "未知问题回复": "Unknown question reply",
    "相似问题引导": "Similar question guidance"
  },
  "sdk": {
    "put_set": "Access settings",
    "web": {
      "methods": "Access methods",
      "exe_robot": "Web robot demo",
      "text1": "Click on the web robot demo, or click on the Copy URL to get the URL of the Web Robot page we generated for you",
      "quick": "Quick experience",
      "copy_url": "Copy URL",
      "put": "Access web robot",
      "text2": "We provide two ways for robots to access your Web pages",
      "method1": "Method 1",
      "me1_info": "Access by Web JS",
      "text3": "You can access the robot using the JS components we provide",
      "text4": "Paste the following code directly into your page to access the robot",
      "text5": "The style of the robot component can be configured in the code. For more information, please refer to the Access Document:",
      "me1_info_file": "Web JS Access Document",
      "method2": "Method 2",
      "me2_info": "Web Custom UI Access",
      "text6": "You can customize the development of chat window style and other functions, only call the interface we provide to achieve the function of the robot",
      "text7": "The following Access Key is passed in as an initialization parameter for SDK. Refer to Access Documents:",
      "me2_info_file": "Web Custom UI Access Document",
      "put_view": "Preview",
      "text8": "Enter the link click preview of the access page to preview the effect of the robot’s access",
      "link_err": "Please enter the correct link。",
      "link_holder": "Enter links to access pages",
      "text9": "Your web page may be blocked by the browser if it is transmitted through an insecure connection. Please allow the browser to load the web page manually",
      "re_view": "Preview",
      "quick_set": "Quick Setting",
      "own_style": "Custom Consulting Window Style",
      "set_button_style": "Setting up the Consultation Button’s style",
      "set_button_position": "Setting up the Consultation Button’s position",
      "sys_style": "System style",
      "step1": "1.Select the entry label style",
      "online_cus": "Online customer service",
      "step2": "2.Select the color of the entry label",
      "choose_view": "Preview after selecting entry style",
      "own_set_style": "Custom style",
      "set_dialog": "自定义设置对话框和图标的样式",
      "up_icon": "1.Upload entry Icon",
      "icon_size": "Recommended size 300px*300px, jpg/png/gif format",
      "up_image": "Upload pictures",
      "up_view": "Preview after uploading pictures",
      "t_b": "Top&bottom position",
      "top": "Distance from the top of the page",
      "bottom": "Distance from the bottom of the page",
      "l_r": "Left&right position",
      "left": "Distance from the left of the page",
      "right": "Distance from the right of the page",
      "set_style": "Setting dialog style",
      "bg_color": "Message box background color",
      "font_color": "Message box font color",
      "bg_color1": "收消息框背景颜色",
      "font_color1": "收消息框字体颜色",
      "title_back": "Background color of title bar",
      "send_color": "Send button color",
      "set_size": "Set the dialog box size",
      "font_size": "设置对话框字体大小",
      "px": "px",
      "h": "Height",
      "w": "Width",
      "copy": "Copy",
      "save_succ": "Successfully saved!",
      "edit_succ": "Successfully edited",
      "box_style": "邀请框样式",
      "change_back": "更换背景图片",
      "upload_tip": "只能上传不超过2M的图片，且大小不超过800*700px",
      "box_choose": "邀请框功能区域框选",
      "box_close": "框选关闭区域",
      "box_open": "框选打开对话框区域",
      "box_open_close": "并关闭邀请框",
      "pop_set": "弹出设置",
      "first_time": "首次发起延时",
      "re_open": "开启反复发起",
      "wait_time": "发起间隔",
      "max_num": "最大发起次数",
      "out_line": "开启离线自动发起",
      "explain": "当所有客服不在线时，依然根据规则自动弹出邀请框",
      "box_show": "邀请框预览",
      "mouse_down": "在虚线框内,按下鼠标",
      "image_err": "图片格式不正确",
      "image_max": "图片不能大于2M",
      "image_h_w": "图片高度不能大于700, 宽度不能大于800!",
      "web_js": "Web JS接入功能设置",
      "open_box": "开启邀请框",
      "sub": "邀请框在您接入的页面按照一定规律主动弹出邀请用户联系客服",
      "box_set": "邀请框设置",
      "color_set": "配色设置",
      "pre_select": "预选方案：",
      "color_default": "默认配色",
      "color_wechat": "微信配色",
      "color_define": "自定义",
      "color_setting": "颜色设置：",
      "tag_empty": "Please firstly select the entrance label style"
    },
    "app": {
      "title": "Mobile APP access",
      "methods": "Access App",
      "me1_info": "Access App SDK",
      "text1": "Through App SDK, the fourth paradigm of smart customer service can be connected to your App, allowing users to initiate customer service consulting in your App",
      "text2": "You can customize all UI styles of the chat interface we provide; if you develop the App chat interface yourself, you can also call the interface to implement all the functions of smart customer service",
      "text3": "Detailed access methods can be referred to:",
      "file1": "Intelligent Customer Service Android SDK Access Document",
      "file2": "Intelligent Customer Service iOS SDK Access Document",
      "file3": "Download Intelligent Customer Service Android SDK",
      "file4": "Download Intelligent Customer Service iOS SDK",
      "text4": "If you want to experience the functions of SDK before accessing, you can scan the corresponding two-dimensional code below and download the installation sample program",
      "support_version": "support version",
      "v1": "Android 4.0 and above",
      "v2": "IOS 8.0 and above",
      "text5": "Access Key is the unique identifier of the robot you bind to, and can be accessed through the Demo program",
      "scan": "Scan",
      "auto": "Manual",
      "me2_info": "Embedding Consultation Page Links in App",
      "text6": "If you don’t want SDK access, you can insert the link below into App, and the user jumps to the consulting page for consultation. But this method can not identify the identity and data of the logged-in user",
      "text7": "Scan and get Access Key",
      "copy_succ": "Successfully copied!"
    },
    "public": {
      "text1": "Wechat Subscription Access",
      "text2": "Subscription Authorized Access",
      "text3": "Click on the button below, scan the two-dimensional code with the public number administrator’s micro-mail, confirm the authorization, and then complete the binding of the robot. Robots can receive messages from users and reply to them",
      "text4": "Subscription Authorization",
      "text5": "Reminder:",
      "text6": "1. The authorization of the subscription has no effect on the configuration of the Wechat backstage and the third-party backstage. All functions of the Wechat subscription backstage can continue to be used, such as: mass distribution function, public address, custom menu, data statistics, etc",
      "text7": "2. Because of the limitation of the message forwarding mode of Wechat itself, after authorizing the \"message management authority\" to the third party platform, new messages sent by users through public numbers will only be sent to the third party, and Wechat will no longer send messages to the multi-customer service background of Wechat",
      "text8": "Embedding the link of consulting page in the custom menu of wechat",
      "text9": "Please insert the link below into the Wechat Custom Menu, and the user jumps to the Consultation Page for consultation. But this method can not identify the identity of micro-credit users",
      "text10": "Wechat Subscription Accessed",
      "text11": "2.Unauthorized subscription can’t be accessed to Human customer service"
    },
    "program": {
      "text1": "Authorized Access",
      "text2": "After the Wechat apps scan authorization, the robot can receive and reply the customer service message uniformly",
      "text3": "Wechat apps Access",
      "text4": "Note: If you want to appear the customer service consulting button in Wechat apps, please insert the following code in the code",
      "text5": "Customer Service",
      "text6": "* Button style can be defined by code, please refer to the official instructions of Wechat applet specifically:",
      "text7": "Wechat apps Accessed",
      "text8": "其中参数nickName为微信昵称,avatarUrl为微信头像需要开发者自己获取后传入",
      "text9": "插件接入",
      "text10": "自定义设置小程序插件对话框和咨询按钮的样式：",
      "text11": "扫码体验小程序插件",
      "text12": "体验小程序",
      "scan": "扫码",
      "get": "获取AccessKey",
      "text13": "2. 引入插件代码包",
      "text14": "在小程序项目的app.json中声明需要引用的插件appid及版本号",
      "text15": "3. 在小程序页面引入插件",
      "text16": "在页面的json文件中定义需要引入的第四范式智能客服机器人插件，使用plugin://协议",
      "text17": "在页面的wxml文件中声明插件（需保证在一个页面中仅引入该插件） , 其中参数nickName为微信昵称,avatarUrl为微信头像需要开发者自己获取后传入",
      "text18": "Access Key需要作为插件的初始化参数传入。使用体验小程序时可以直接",
      "icon_empty": "Please firstly upload the entrance icon"
    },
    "company": {
      "wechat": "Enterprise WeChat",
      "no_wechat": "No enterprise wechat",
      "add_wechat": "Please add enterprise wechat",
      "name": "Enterprise wechat name",
      "id": "Enterprise ID",
      "time": "Access time",
      "unbind": "Disaccess",
      "unbind_wechat": "Disaccess enterprise wechat",
      "text1": "If you want to disaccess the enterprise Wechat, click the confirmation button, and go to the enterprise Wechat background \"Enterprise Application\" - \"Self-built Application\" - \"API Receive Messages\" to click delete",
      "text2": "Fill in the following input box with the name of the enterprise Wechat you want to receive:",
      "text3": "Log in to your enterprise Wechat management background, find the enterprise ID in \"My Enterprise\" - \"Enterprise Information\" (refer to the figure below), and fill in the following input box:",
      "text4": "Click on \"Create Application\" in \"Application and Small Programs\" of Enterprise Wechat Management Background - \"Self-built Application\". After the creation, you can see AgentID and Secret. Fill in the following input box:",
      "text5": "On the inner page of the created application, find the \"Receive Message\" item, click \"Set API Receive\", and then copy the URL address generated below to it:",
      "step3": "Step 3",
      "text6": "Copy the Token and Encoding AESKey generated in the background of Enterprise Wechat in the figure above into the input box below and click Save. don’t forget to check the success of the docking in the background of Wechat",
      "pre_step": "Previous step",
      "next_step": "Next step",
      "com_id_err": "Enterprise IDs must be composed of numbers, letters or underscores",
      "ag_id_err": "AgentID must consist of pure numbers",
      "sec_id_err": "Secret must be composed of numbers, letters or underscores",
      "token_id_err": "Token must be composed of numbers or letters",
      "aes_id_err": "EncodingAESKey must be composed of numbers, letters or underscores",
      "name_empty": "Please enter the name of Enterprise Wechat",
      "back_sure": "Confirm return? (Information filled in may be lost)",
      "cancle_back": "Cancel back"
    },
    "person": {
      "wechat": "Access personal wechat",
      "fresh": "click to refresh",
      "text1": "Please scan the left QR code with Wechat and click to confirm your login",
      "text2": "After login, this page will jump. You can select the Wechat Friends and Wechat Group Access Robot in the jump page. When a friend sends a message or @you in a group chat, the robot responds to the message on its own initiative",
      "text3": "1. The QR code may be invalid. Please wait a moment to refresh the QR code or refresh the page directly",
      "text4": "2. If you fail to log in many times, please confirm",
      "text5": "Web Wechat",
      "text6": "login normally or not",
      "text9": "2. 手机扫码后可能会提示账号在其他城市登录，请忽略并继续；",
      "text10": "3. 扫码授权成功后请不要在其他电脑或iPad上登录账号，否则机器人会自动离线",
      "status": "Status: Online",
      "unbind": "unbind",
      "per_auto": "Personal Wechat Automatic Response",
      "gro_auto": "Wechat Group Automatic Response",
      "open_auto": "Turn on automatic reply",
      "open_all_auto": "Turn on all friends automatically reply",
      "choose_fr": "Select which Wechat friends to open automatic response",
      "per_holder": "Enter Wechat nickname to search for friends",
      "per_list": "All friends list",
      "add_all_per": "Add all users",
      "opened_per_list": "Friends with automatic replies list",
      "all_remove": "Remove all",
      "choose_gro": "Select which Wechat groups to open automatic response",
      "gro_holder": "Input Wechat group nickname search group chat",
      "gro_list": "All groups list",
      "add_all_gro": "Add all groups",
      "opened_gro_list": "Group list with auto-reply turned on",
      "text7": "1.Make sure you don’t log on to any device other than the current scanner, otherwise the robot will be offline and the service will be interrupted",
      "text8": "2.The \"Webpage Wechat is logged in\" notification at the top of the mobile phone Wechat indicates that Wechat has successfully bound the robot service. Please do not click to exit",
      "per_put_err": "Personal Wechat access failed, Please rescan the code attempt!",
      "login_out": "Your account has been kicked out, please log in again!",
      "open_fr": "选择对哪些好友进行自动回复",
      "close_fr": "选择不对哪些好友进行自动回复",
      "closed_fr": "已关闭自动回复的好友列表",
      "group_at": "群@回复",
      "reply_at": "回复@我的消息",
      "reply_all": "回复所有消息",
      "add_greet": "添加入群欢迎语",
      "create_greet": "新建入群欢迎语",
      "edit_greet": "编辑入群欢迎语",
      "delete_sure": "Confirm to delete the welcomes?"
    },
    "weibo": {
      "add": "Add Weibo visitors",
      "open_file": "Click to open help document",
      "no_visitor": "No Weibo visitors yet，",
      "please_add": "Please add Weibo visitors",
      "accessed": "Accessed to Weibo Account",
      "delete_visitor": "Delete Weibo visitors",
      "delete_text": "Hello, while deleting this record, you also need to disable the development mode in the personal homepage of Weibo - Management Center - Fan Service - Developer Center. Refer to the last step of the documentation:",
      "nick_empty": "Please enter nickname",
      "access_empty": "Please enter Access Token",
      "weibo_help": "Access Instructions",
      "text1": "Step 1: Copy the URL and AppKey separately for filling in the background of Weibo (see the next page for filling in the background of Weibo)",
      "text2": "Step 2: Fill in the duplicated URL and AppKey in the input box of the page, and click Save. Due to the instability of microblog service, if the prompt is wrong, please refresh the page and try again several times",
      "text3": "Step 3: If the page shown below indicates that you have successfully bound to Weibo, copy the access_token field for the next step. Because the Weibo service is unstable, if the field is empty, please refresh it several times",
      "text4": "Step 4: Please fill in the Weibo nickname and access_token copied in the previous step. Click Save to complete the binding",
      "text5": "Step 5: If you want to modify the bound robot or disable the robot, please see the following figure"
    },
    "api": {
      "access": "API access",
      "product": "API function can be used to connect more service modes with the parameter as follows to the intelligent customer service:",
      "show": "Display",
      "detail": "For the details please see",
      "doc": "API usage document",
      "req_example": "Request examples as follows",
      "res_example": "Return examples as follows"
    },
    "wechat": {
      "desc": "You can use the Weiyi assistant platform to connect the robot to WeChat in a more stable way. The Weiyi assistant platform provides more functional services focused on personal WeChat use",
      "to": "Click to Weiyi assistant",
      "sub": "Continue to use the intelligent customer service, click the button below, scan the QR code with Wechat and confirm authorization login to complete robot binding. The robot can receive the message from users and then reply them",
      "wx_qr": "Personal WeChat authorization log in",
      "info": "Personal Wechat connection channel will be closed since Feb. 26th, 2020 due to the demand of the platform operation (except Official Accounts, enterprise Wechat and mini Apps). Please connect to other channels in case of channel closing affecting your business",
      "set": "Personal Wechat setting",
      "person_set": "Personal setting",
      "failure": "QR code has expired",
      "re_load": "Please click to reload",
      "scan": "Use mobile phone and WeChat scan to login",
      "click_login": "Please click the confirm button on the mobile phone and log",
      "unbind": "Lifting the bind",
      "fr_msg": "Friends private chat setting",
      "fr_switch": "Master switch for friends private chat",
      "text1": "The following setting will all be invalid if the switch is off",
      "fr_auto": "Automatic answer for adding new friends",
      "text2": "Automatically pass new friends’ authentication and send some welcomes",
      "edit_greet": "Edit welcomes",
      "fr_to_group": "Friends automatically enter Wechat group",
      "keyword_group": "Trigger key words to automatically invite friends to enter the specified Wechat group",
      "add_keyword": "Add key words for automatic entering Wechat group",
      "keyword": "Keywords",
      "group_info": "Group message",
      "edit_gr_keyword": "Edit key words for automatic entering Wechat group",
      "response": "Automatic reply to private chat",
      "fr_white": "Select friends with automatic reply",
      "fr_black": "Select friends with blocking automatic reply",
      "choose_white": "Select friends to whom replying automatically",
      "choose_black": "Select friends to whom blocking automatic reply",
      "load": "If your friends displaying is incomplete, please wait patiently for its loading",
      "open_fr": "Friends list of automatic rely",
      "close_fr": "Friends list of blocking automatic reply",
      "cancle_auto": "Cancel auto-response",
      "open_auto": "Open auto-response",
      "gr_set": "Group chat setting",
      "gr_switch": "Master switch for Wechat group",
      "opend_gr": "Wechat group with automatic reply button on",
      "group_set": "Group setting",
      "choose_gr": "Select Wechat group to which replying automatically",
      "load_gr": "If Wechat group displaying is incomplete, please wait patiently for its loading",
      "content_detail": "Mass texting content details",
      "keyword_holder": "Please enter the keyword",
      "keyword_mult": "Key words repeated",
      "open_list": "Unlock key words group entry list",
      "cancle_keyword": "Cancel key words group entry",
      "open_keyword": "Unlock key words group entry",
      "max_fr": "Select 500 for the upper limit of friends",
      "max_gr": "Select 100 for the upper limit of Wechat group",
      "max_greet": "The quantity of welcomes for automatic reply is 10 at most",
      "max_keyword": "The quantity of key words for automatic entering Wechat group is 10 at most",
      "delete_sure": "Do you want to delete the key words?",
      "method": "group entry mechanism？",
      "gr_msg": "The quantity of batch sending messages to friends and Wechat group is no more than 10",
      "delete_timesend": "Do you want to delete the scheduled batch sending messages?"
    },
    "qq": {
      "access": "QQ access",
      "use": "You can use",
      "cqp": "Cool Q",
      "text1": "The platform connects the intelligent customer service to QQ through plugins, which support automatic reply to private chat and @ reply to Wechat group/discussion group",
      "step1": "Step 1Download",
      "cqp_air": "Cool Q Air (For free)",
      "cqp_pro": "Cool Q Pro (Charge)",
      "install": "Install and log in QQ",
      "sub": "Cool Q Air supports text message only, while Cool Q Pro supports more diverse message types like image, voice, as well as the combination of image and text, etc",
      "detail": "More details please see：",
      "cqp_air_pro": "Cool Q air / Pro function comparison",
      "notice": "Attention：",
      "no_text1": "1、The difference between Turing and XiaoAi only lies in their own plugins, and you can select any version to download",
      "no_text2": "2、Cool Q now only supports Windows7 and above operating systems",
      "step2": "Step 2Install Cool Q voice component",
      "install_step": "Install steps",
      "step3": "Step 3Install the intelligent customer service plug-in",
      "address": "Download address",
      "desc": "Please copy the downloaded com.4paradigm.bot.cpk to app catalog of Cool Q",
      "step4": "Step 4Configure API key",
      "desc2": "In the application settings of Cool Q, enable plugins of 4Paradigm robot, click setting in the menu, and then the following API Key",
      "write": "Shall be filled in and then restart loading application after saved",
      "finish": "Configuration complete! Automatic reply can be made now though logged QQ",
      "load_err": "If plugins loading failed (error code-103), please try to download installation "
    }
  },
  "history": {
    "time_scope": "Create time range",
    "choose_start": "Start time",
    "choose_end": "End time",
    "from": "Channel",
    "search": "Search",
    "import_cur": "Import current data",
    "con_id": "Conversation ID",
    "visitor": "Visitor",
    "no_con": "No conversation yet",
    "con_detail": "Detail",
    "con_start": "Beginning time",
    "con_end": "Finishing time",
    "no_msg": "No message",
    "export": "Export",
    "going": "Going",
    "close": "Closed",
    "con_create": "Create time",
    "custom": "Customer service",
    "history_detail": "Past conversation detail",
    "evaluation": "Evaluate",
    "open_visitor": "Open guest side",
    "copy": "Backup format",
    "rule": "Q&A pack format"
  },
  "transfer": {
    "user": "Customer",
    "and": "and",
    "set_con": "Build conversation",
    "over_con": "finish this conversation",
    "trans": "transfer conversation to"
  },
  "message_res": {
    "ask": "Ask",
    "click_tap": "Click on trigger answer recommendation",
    "sug_answer": "Recommended answers",
    "no_sug": "No recommendation",
    "identify": "Recognition results",
    "is_menu": "This is a menu",
    "list1": "Option 1",
    "title": "Title",
    "len_des": "This is a description…",
    "is_qustion": "Are you asking the following questions?"
  },
  "data_statistic": {
    "time": "Time range",
    "start": "Start time",
    "end": "End time",
    "vi_count": "Visitors count",
    "con_count": "Conversation count",
    "msg_count": "Message count",
    "hot_rules": "Hot Q&A",
    "no_data": "No data",
    "vi_trend": "Visitor trend",
    "con_trend": "Conversation trend",
    "msg_trend": "Message trend",
    "channel_st": "Channel statistics",
    "star_q": "Standard questions",
    "belong": "Category",
    "hit": "Hit count",
    "fit_rate": "Matching rate",
    "no_answer": "No- reply question",
    "direct_answer": "Straightly reply question",
    "guide_answer": "Leading questions",
    "cur_time": "Current time range",
    "statistic_trend": "Data statistics trend",
    "访客统计": "visitors statistics",
    "问答统计": "Q&A statistics"
  },
  "custom_service": {
    "访客端设置": "Guest side setting",
    "访客端咨询窗口设置": "Information window setting of visitor side",
    "广告框窗口设置": "Advertising window setting",
    "上传失败": "Upload failed",
    "转人工设置": "Transfer to staff service setting",
    "开启自动关闭会话": "Turn on the button of automatic session closing",
    "关闭会话时间": "Turn off session time",
    "客服在指定时间无响应，将在指定时间内自动关闭会话": "The customer service does not respond within the specified time and the session will be automatically closed within the specified time",
    "open_advertisement": "Open advertising window",
    "advertisement_title": "Advertising window setting",
    "user_set_title": "用户端设置",
    "advertisement_advice": "开启后可在web聊天窗口右侧添加自定义广告窗口",
    "arti_first": "Human first",
    "text1": "Starup this function, visitor can straightly chat with human customer service, rather than robot",
    "text2": "You can set commuting time, human priority in the set time, robot priority in other time",
    "set_time": "Set commuting time",
    "smart_first": "Starup intelligence transfer",
    "text3": "By default, robots are preferred in the system. Users click on buttons to transfer to human customer service, which can turn on and set the way of intelligent transfer to human service",
    "click": "Click",
    "max_limit": "Upper limit",
    "time_count": "undefined questions, transfer to human service",
    "click_keyword": "Trigger keywords to transfer to human",
    "show_arti": "Show the transfer button",
    "text4": "If you want the user to consult the manual customer service, you can turn the manual button to display",
    "leave_msg": "Open message contact",
    "text5": "It is suggested that mailboxes should be opened to facilitate visitors to inquire about the progress of work orders by mail",
    "input_must": "Essential",
    "input_no_must": "Nonessential",
    "allot": "Allocation settings",
    "text6": "The system provides two basic allocation modes to assign users to specific customer service:",
    "text7": "Polling Allocation: according to the customer service accounts’ create time，take turns to allocate visitors",
    "text8": "Saturation Allocation: Allocate users to the customer service with the lowest current saturation (reception saturation = number of people received/number of people capped), and randomly allocate if saturation is the same",
    "turn_allot": "Polling Allocation",
    "saturate_allot": "Saturation Allocation",
    "freq_first": "Acquaintance first",
    "text9": " hours within， revisiting users will be assigned to the customer service they received last time.（between 1 and 999, and the last two decimal points are input at most）",
    "forever": "Permanent",
    "consult_set": "Client consulting window settings",
    "can_image": "Allow users to upload pictures",
    "text10": "After opening, users can send pictures while chatting with robots",
    "robot_feed": "Robot response feedback",
    "text11": "Useful feedback from customers on the robot’s response can be seen in the business question and answer module and the statistical module to see the usefulness of the robot’s response, so as to improve the configuration of the knowledge base",
    "keyword_shiled": "Wechat keyword shielding",
    "text12": "You can set keywords, and the robot will not reply when the user enters these keywords in the public number. Perfect matching refers to a visitor’s input text hitting the keyword completely. Inclusive matching refers to the input text containing the keyword",
    "pub_list": "Subscription list",
    "keyword_set": "Keywords settings",
    "no_pub": "No subscription yet",
    "equal": "Perfect matching",
    "contain": "Inclusion matching",
    "clear_sure": "Do you want to empty",
    "key": "Keywords",
    "add_keyword": "Click here to add keywords",
    "all_date": "All dates",
    "time_scope": "Time range",
    "mon": "Monday",
    "tus": "Tuesday",
    "wed": "Wednesday",
    "thur": "Thursday",
    "fri": "Friday",
    "satur": "Saturday",
    "sun": "Sunday",
    "date_empty": "Please choose at least one date!",
    "date_scope": "Please choose the right time range!",
    "delete_time": "Are you sure to delete the set commute time?",
    "time_empty": "Time shouldn’t be empty！",
    "time_err": "Time ranges from 1 to 999, the maximum input decimal point after two!",
    "time_nan": "Please enter the correct time!",
    "to": "to",
    "like_review": "Human Satisfaction",
    "like_evaluate": "Satisfaction evaluation",
    "text13": "Set satisfaction labels, collecting users’ feedback",
    "start_review": "Open human satisfaction",
    "add_review": "Add labels",
    "set_star": "Set labels for every star",
    "no_star_mark": "Add labels first",
    "one_star": "1 Star",
    "two_star": "2 Star",
    "three_star": "3 Star",
    "four_star": "4 Star",
    "five_star": "5 Star",
    "set_guide": "Guiding question settings",
    "text14": "Robots can automatically understand the user’s problems and guide the consultation based on the existing problems in the knowledge base",
    "start_guide": "Open guiding question",
    "auto_text": "Customize guiding text",
    "guide_count": "Numbers of guiding question",
    "adk_qus": "Do you want to ask following questions？",
    "remark_warn": "At most 100 labels!",
    "add_succ": "Successfully added!",
    "max_add_star": "At most 20 labels for each star!",
    "delete_sure": "Certain to delete?"
  },
  "group_recept": {
    "title": "Group reception",
    "text1": "After opening group reception, users can choose business before consulting, and the system assigns users to corresponding business groups",
    "start_gro": "Open group reception",
    "name": "Group name",
    "busi_group": "Referring business group",
    "change_err": "Please set up the group below and then open it!",
    "busi_empty": "Please select the corresponding business group first!",
    "name_empty": "Please enter the name of the business group first!！",
    "add_succ": "Successfully added!",
    "delete_succ": "Certain to delete?",
    "no_group": "You have no business group",
    "add_first": "Please add first",
    "add_group": "Add group reception",
    "edit_recept": "Edit grouping",
    "add_recept": "Add grouping",
    "edit_succ": "Edit grouping successfully"
  },
  "commute_yunying": {
    "group_info": "Group message",
    "group_detail": "Group message details",
    "choose_time_per": "Select WeChat friends to which scheduled sending opening",
    "opened_time_per": "Friends list with scheduled sending opening",
    "choose_time_gro": "Select Wechat group to which scheduled sending opening",
    "opened_time_gro": "Wechat group list with scheduled sending opening"
  },
  "platform_vue": {
    "search_con": "Search",
    "choose_user": "Select a user and start a conversation",
    "transfer": "Transfer",
    "create_order": "Create work order",
    "close_con": "Close conversation",
    "get_history": "more historic messages",
    "text_holder": "enter #+keywords and select the quick reply",
    "send_text": "shift+enter changes another line, enter sends message",
    "user_info": "User information",
    "quick_reply": "Quick reply",
    "content_empty": "Please input some contents",
    "company": "Company",
    "city": "City",
    "note": "Notes",
    "ip_address": "IP",
    "terminal": "Terminal",
    "system": "System",
    "pack": "Pack",
    "open": "Open",
    "image_view": "Image preview",
    "order_title": "Title",
    "order_content": "Content",
    "order_info": "Information",
    "agent_cus": "Assign",
    "vi_info": "Visitor information",
    "vi_name": "Visitor name",
    "vi_username": "Visitor name",
    "vi_tel": "Visitor telephone",
    "vi_mail": "Visitor email",
    "create": "Create",
    "name_search": "Search by username&nickname",
    "fresh_at": "refreshed at:",
    "cus_name": "Customer service name",
    "cus_nick": "Customer service nickname",
    "recept_status": "Reception status",
    "online": "Online",
    "busy": "Busy",
    "outline": "Offline",
    "no_data": "No data yet",
    "title_empty": "Please enter work order title",
    "content_req_empty": "Please enter work order content",
    "reply_empty": "Please enter reply content",
    "vi_name_empty": "Please enter visitor name",
    "vi_username_empty": "Please enter the visitor name",
    "create_succ": "Successfully created!",
    "transfer_err": "Transfer failed. The customer service you want to transfer is offline. Please choose another customer service",
    "quick_err": "Quick replies can only be used in the current conversatuon!",
    "recall": "Callback successfully",
    "rec": "Callback",
    "search_rule": "Search knowledge base",
    "no_rule": "No relevant knowledge base information",
    "white": "White colour",
    "red": "Red colour",
    "orange": "Orange colour",
    "yellow": "Yellow colour",
    "green": "Green colour",
    "blue": "Blue colour",
    "all": "All",
    "send_image": "Send picture",
    "send_file": "Send file",
    "send_satisify": "Invite user to make comment",
    "rule_search": "Knowledge base searching",
    "choose_tag": "Select label",
    "add_tel": "Add new number",
    "add_mail": "Add mailbox",
    "send_review": "Preview for the sending picture",
    "have_eva": "This conversation has already been commented on and no more invitations can be made",
    "feedback_succ": "Send comment invitation to user successfully",
    "no_file": "Please select the file",
    "file_max": "File cannot be larger than 10M"
  },
  "platform_left": {
    "cur_con": "Current chat",
    "hist_con": "Past chat",
    "order_center": "Work order center",
    "set": "Settings",
    "paltform_set": "Settings",
    "open_gret": "Automatic greeting",
    "gret_empty": "Please enter greeting",
    "con_sort": "Chat sorting",
    "time_put": "Sort by access time",
    "text1": "Newly accessed users are at the top of the list, and the order is not affected after the user sends the message",
    "msg_put": "Sort by new messages",
    "text2": "Dialogues with new messages automatically move to the top of the list",
    "open_sug": "Automatic recommend answers",
    "open_last_msg": "Automatically recommend answers to the user’s last message",
    "wel_word": "Hello, what can I do for you?",
    "set_succ": "Settings saved!",
    "open_sound": "Open message sound"
  },
  "choose_city": {
    "province": "Province",
    "county": "Country"
  },
  "attachment": {
    "up_atta": "Upload attachment(tt most 10 attachments, single file shouldn’t exceed 20M)",
    "text1": "Limit 10 flies, currently select",
    "text2": "files",
    "text3": "Totally select",
    "remove_sure": "certainly remove",
    "file_limit": "Single uploaded file shouldn’t exceed 20M!"
  },
  "quick_reply": {
    "search": "Search",
    "text1": "No quick reply yet",
    "pub_reply": "Public",
    "per_reply": "Personal",
    "no_reply": "No quick reply yet。",
    "set_quick": "Set quick reply",
    "per": "Personal",
    "pub": "Pubilc",
    "import_relpy": "Import",
    "export_reply": "Export",
    "no_group": "No group yet",
    "pl_add": "You can add one",
    "group_empty": "Please choose a group first",
    "add_group": "Add group",
    "up": "Up",
    "down": "Down",
    "to_top": "Top",
    "add_quick": "Add quick reply",
    "category_empty": "Please choose a category first!",
    "is_delete": "Do you want to delete"
  },
  "all_set": {
    "user_manager": "User management",
    "sys_put": "System docking",
    "work_list_set": "Work order setting",
    "open_auto": "Turn on automatic allocation",
    "text": "After the automatic allocation is turned on, the newly created work order will be automatically assigned to the customer service by roll polling",
    "tag": "Work order label",
    "tag_repeat": "Labels can’t have the same name, please modify"
  },
  "user_manager": {
    "search": "Search",
    "add": "Add users",
    "password": "Password",
    "sure_pass": "Confirm password",
    "user_role": "User role",
    "SYSTEM_ADMIN": "System admin",
    "TENANT_ADMIN": "Super admin",
    "ADMIN": "Admin",
    "TENANT_USER": "Custom service",
    "max_limit": "Max reception number",
    "edit_user": "Edit user",
    "delete_sure": "User will be deleted permanently",
    "is_contin": "Do you continue?",
    "name_le_err": "2 to 15 characters",
    "user_limit": "User authority",
    "again_pass": "Enter password again",
    "agian_err": "Two passwords are diffirent!",
    "rule_name": "Q&A pack name",
    "all_category": "All classifications",
    "limit": "Jurisdiction",
    "disabled": "Disabled",
    "expired": "Expired",
    "normal": "Normal",
    "limit_manager": "Jurisdiction management",
    "limit_succ": "Modify jurisdiction successfully",
    "user_max": "Your agent has reached the upper limit. Contact business engineer to upgrade and unlock more agents"
  },
  "tenant_manager": {
    "add": "Add tenant",
    "edit": "Edit tenant",
    "search": "Search tenant",
    "no_data": "No tenants at present",
    "address": "Invoice address",
    "phone_number": "Mobile number",
    "mail": "Mailbox",
    "user_count": "Number of customer services that can be created",
    "set_phone": "Please enter the correct phone number",
    "set_name": "Please enter the tenant name",
    "set_name_err": "Tenant name should be 2 to 15 characters",
    "new_suc": "Create tenant successfully!",
    "company": "Company name",
    "set_company": "Please enter the company name",
    "set_address": "Please enter the invoice address",
    "name": "Tenant account",
    "time": "Service life",
    "tenant_name": "Account"
  },
  "system_butt": {
    "text1": "You can use iframe to embed docking pages in the workbench to realize data and function docking between customer service system and your CRM, order, work order and other systems. Docking methods can be referred to:",
    "butt_file": "Docking files",
    "show_key": "Key",
    "add_pages": "Add pages",
    "delete_sure": "Are you sure to delete the page?",
    "title_empty": "Please enter title",
    "address_empty": "Please enter page address",
    "all_address": "Only complete page address begun with http:// or https:// can be supported",
    "max_size": "At most 300 characters",
    "page_title": "Page title",
    "page_address": "Page address",
    "open_status": "Open status",
    "open_methods": "Open methods",
    "active_status": "Active status",
    "new_page": "New page",
    "cur_page": "Current page",
    "max_ten": "At most 10 characters",
    "text2": "Address begun with https is better. The http ones may be invalid sometimes"
  },
  "group_list": {
    "set": "Business group settings",
    "belong": "Belonging group",
    "default": "Default group",
    "no_list": "You haven’t add group yet",
    "text1": "Business group is used to distinguish different business of visitor consultation. Customer service can be configured in different business groups to receive (one customer service can be in multiple business groups)",
    "text2": "You can divide customer service staff into different business groups. After the group reception is turned on, the system will allow users to select services before consultation, and according to the selection, users will be assigned to the corresponding customer service in the corresponding business group",
    "add_list": "Add group",
    "name": "Group name",
    "count": "Group service number",
    "id": "Group ID",
    "no_group": "No group",
    "edit_list": "Edit group",
    "name_empty": "Please enter group name",
    "add_succ": "Successfully added!",
    "edit_succ": "Successfully edited!",
    "delete_succ": "Deleting the business group will affect the relevant data statistics, while deleting the corresponding grouping in the grouping reception. Do you want to continue?",
    "bind_address": "Bind address",
    "text3": "Select a robot to create a binding link, and users accessed through this link will go directly to the customer service of this business group when transferring to staff service",
    "choose_robot": "Select robot",
    "create_link": "Create link",
    "copy_succ": "Copy link successfully"
  },
  "work_list": {
    "my_work": "My Work Order",
    "m_create_work": "My Created Work Order",
    "m_deal_work": "My Handling Work Order",
    "all_work": "All Work Order",
    "a_un_allot": "All Non-distributed Work Order",
    "a_dealing": "All Handling Work Order",
    "a_resolve": "All Resolved Work Order",
    "a_close": "All Closed Work Order",
    "create_channel": "Create channel",
    "work_status": "Work order status",
    "work_num": "Work order number",
    "user_group": "Business group",
    "no_work": "No Work Order",
    "num": "Number",
    "update_time": "Update time",
    "receive_work": "Receive",
    "exit_no_perssion": "There’re some unauthority work order",
    "un_allot": "Non-distributed",
    "dealing": "Handling",
    "resolved": "Resolved",
    "colsed": "Closed",
    "cur_cus": "Current customer",
    "reply_work": "Reply",
    "all_show": "All related person can see",
    "only_cus_show": "Only customer can see",
    "work_list": "Work order list",
    "choose_err": "Please select the work order you want to export",
    "delete_sure": "Are you sure to delete the selected work order?",
    "delete_sure_one": "Do you want to delete work order?",
    "receive_work_succ": "Successfully receive",
    "resolve_succ": "Done",
    "deal_work": "Handle work order",
    "deal_progress": "Progress",
    "no_progress": "No progress",
    "work_reply": "Reply",
    "work_create_info": "Create information",
    "creater": "creator",
    "tag": "Label",
    "delete_sure_mul": "Confirm to delete the selected",
    "order_count": "(Number of) work orders?",
    "unkonwn_count": "(Number of) unknown questions?"
  },
  "line_list": {
    "title": "Session is waiting to be connected",
    "access": "Access",
    "group": "Business group",
    "no_con": "There is no session waiting to be connected",
    "success": "Multitap successfully",
    "line_time": "Start queuing time "
  },
  "union": {
    "union": "Platform version",
    "common": "Normal edition",
    "cvs": "Session record",
    "work": "Work order record"
  },
  "login": {
    "robot": "小式智能机器人",
    "cus": "您身边的智能客服",
    "paradigm": "4th paradigm, top AI technology company",
    "advance": "Connect to all channels in minutes, all functions are FREE",
    "union_advance": 'Platform edition provides functions of unified management and analysis & statistics for multi-business customer services',
    "login": "login",
    "forget_pass": "forget password",
    "no_id": "If you don’t have an account,",
    "create": "Signup",
    "title": "4th paradigm intelligence customer service"
  },
  "register": {
    "register": "Register",
    "username_holder": "Username should be 2-15 characters, support English, numbers, Chinese, underlines",
    "pass_holder": "Password should be 6-15 characters",
    "company_holder": "Company/Team name",
    "verify_holder": "Please enter verification code",
    "send_verify": "Send verification code",
    "second_resend": "Resend after %s minutes",
    "read_recep": "Read and accept",
    "protol": "User Protocol for Intelligent Customer Service Cloud Service of Fourth Paradigm",
    "protol_err": "Please check this option: read and accept User Protocol for Intelligent Customer Service Cloud Service of Fourth Paradigm",
    "have_id": "If you already have an account, you can login",
    "image_code": "graphic verification code",
    "image_code_holder": "Please enter graphic verification code",
    "username_exist": "Username has already existed",
    "company_empty": "Please enter your company",
    "company_name_empty": "Please enter your company name",
    "mail_empty": "Please enter your email",
    "register_succ": "Successfully register",
    "position_empty": "Please enter your job title",
    "industry_empty": "Please enter your industry",
    "channel_empty": "Please fill in the channel through which you get to know our products",
    "want_channel": "Your preferred using channel"
  },
  "reset_password": {
    "reset_pass": "Reset password",
    "login_page": "Login page",
    "reg_tel_holder": "Please enter registered cellphone",
    "new_pass": "Please enter new password",
    "new_pass_sure": "Please confirm new password",
    "validate_err": "You don’t pass the check",
    "reset_succ": "Successfully reset"
  },
  "protocol": {
    "protocol": "第四范式智能客服云服务用户协议",
    "service": "服务条款",
    "info1": "欢迎您使用第四范式（北京）技术有限公司提供的智能客服云服务（以下简称：第四范式），请仔细阅读下列内容并在明确理解的前提下注册。为获得第四范式所提供的智能客服云服务，您需要同意本条款内容并按照页面上的提示完成注册程序。如果您在注册过程中勾选“同意遵守【第四范式智能客服云服务条款】”选项即表示完全接受本条款的所有内容，并且在知情的基础上明确同意按条款的规定处理和使用。如果您不接受本条款，请不要注册、使用或以其他方式访问我们的服务。“我们”：即服务提供方第四范式（北京）技术有限公司，依法独立拥有第四范式智能客服产品著作权。”本协议“、”本条款“：即【第四范式智能客服云服务使用协议】，本协议适用且仅适用于第四范式智能客服云服务，第四范式（北京）技术有限公司拥有在法律允许范围内对本协议的解释权。第四范式（北京）技术有限公司公司网址为",
    "content": "服务内容",
    "info2": "第四范式智能客服云服务内容由第四范式（北京）技术有限公司提供给您，我们保留随时修改本条款的权利，并会在修改后于本页面公布修改后的文本，因此，请经常查看本页。如果您继续使用我们的服务，就视同接受我们对本条款的修改。第四范式智能客服云服务主要向用户提供智能客服云服务，用户通过网站导入知识库等内容，进行必要的配置，即可通过多种渠道（包括但不限于微信，微博，手机App，Web等）使用第四范式提供的智能客服云服务。为改善智能客服服务质量，本服务会记录用户数据（包括但不限于对话历史数据、手机APP信息等）。在本服务中，您应同意在您的产品（包括但不限于移动应用客户端、移动网站、应用平台及其他终端等）中使用第四范式智能客服手机SDK工具，并且通过您与您的产品用户的服务协议/软件许可条款或其他形式的许可或授权（“用户授权”），获得您产品用户的必要同意以使得第四范式智能客服手机SDK工具有权收集有关您产品的使用情况的原始数据以及其他为提供服务所必须的用户信息。您充分理解和同意，获得用户授权是使用第四范式智能客服云服务的必要前提，因此第四范式有权监督用户授权的获取，并对未获得用户授权的产品停止服务。同时，您应赋予我们对这些数据的非专有的，全球性质的，永久的，不可撤销的，可进一步许可和使用的权利。除第四范式与您有特殊约定外，本服务所收集的的数据所有权，使用权及其知识产权，均由第四范式保留并享有相关收益。您允许第四范式在提供智能客服服务的过程中插入您指定或者第四范式指定的广告。您同意授权第四范式可以在其网站、市场推广资料和新闻报道中使用您的公司名称、商标、服务标志和或商业标识进行相关的商业推广活动。",
    "rules": "使用规则",
    "info4_1": "1、您需要先同意我们的服务条款及本隐私权政策，成为我们的网站注册账户，才能使用我们的服务。在您注册时，我们会要求您提供个人信息，例如您的姓名、电子邮件地址和密码、电话号码、公司名称等。这些信息视为您的身份识别信息，注册即为您同意我们用这些信息来管理您的账户，并为您提供一系列服务的访问，我们也可以利用这些信息来通知您最新的产品更新和市场活动。您对前述个人信息内容拥有所有权并独立承担全部法律义务，如因该等信息损害软件所有人或他人权益，您应承担全部赔偿责任。",
    "info4_2": "2、您注册成功后，我们将给予您相应的帐号及密码，该帐号和密码由您负责保管，请您不要将您的帐号、密码转让或出借予他人使用。如您发现您的帐号遭他人非法使用，应立即通知我们并授权我们作出处理。",
    "info4_3": "3、确保您在每个上网时段结束时，以正确步骤离开网站。本公司不能也不会对因您未能遵守本款规定而发生的任何损失或损毁负责。除非有法律规定或司法裁定，且征得本公司的同意，否则，您的用户名和密码不得以任何方式转让、赠与或继承（与帐户相关的财产权益除外）。因他人未经授权使用您的用户名和密码造成的损失由您自行承担或依法由擅用人承担，本网站尽力保证您的帐户安全但不保证您帐户安全的绝对性。",
    "info4_4": "4、对于开发者利用本服务所发布的信息，第四范式保留依据国家相关法律法规对其通讯的信息进行关键词过滤的权利，如发现开发者发送内容明确存在违反国家相关法律法规的，第四范式有权作出包括但不限于劝阻、拦截、直至向有关公安部门举报等行为。但这并不表示第四范式对开发者所发送的内容有过滤或审核的义务，也没有任何审查、审核、监督的责任或其他连带责任。开发者需自行对发送该等信息的行为承担一切责任，与第四范式无关，必要时开发者还需承担由此给第四范式造成的相关损失。",
    "info4_5": "5、当您使用第四范式从您的产品终端用户或您的其他合作伙伴获得的数据时，您均已经获得充分必要的授权、同意和许可，不会与您与第三方所签署的协议或文件冲突或构成对第三方权利的侵犯；若您的产品终端用户或您的合作伙伴向您撤销上述授权及许可时，您应当采取必要的技术手段，停止针对上述产品终端用户或合作伙伴使用本服务。",
    "info4_6": "6、您已经遵守并将持续遵守适用的法律、法规和监管要求，包括但不限于有关个人信息保护和隐私保护的相关政策。",
    "secret": "保密条款",
    "info5_1": "1、保密资料指由一方向另一方披露的所有技术及非技术信息包括但不限于产品资料，产品计划，价格，财务及营销规划，业务战略，客户信息，客户数据，研发，软件硬件，API应用数据接口，技术说明，设计，特殊公式，特殊算法等。",
    "info5_2": "2、本协议任何一方同意对获悉的对方之上述保密资料予以保密，并严格限制接触上述保密信息的员工遵守本条之保密义务。除非国家机关依法强制要求或上述保密资料已经进入公有领域外，接受保密资料的一方不得对外披露。",
    "info5_3": "3、本协议双方明确认可各自用户信息和业务数据等是各自的重要资产及重点保密信息。本协议双方同意尽最大的努力保护上述保密信息等不被披露。一旦发现有上述保密信息泄露事件，双方应合作采取一切合理措施避免或者减轻损害后果的产生。",
    "info5_4": "4、本条款不因本协议的终止而失效。",
    "protect": "隐私保护",
    "info6_1": "1、为了给您提供更好的服务，当您注册或者使用第四范式时，服务器会自动记录一些信息，包括URL、IP地址、浏览器的类型和使用的语言以及访问日期和时间等。除了得到您的授权、或者相关政府部门根据法律法规的规定提出要求，我们将不会泄露您的任何信息。",
    "info6_2": "2、我们可能自动从目标智能终端（包括手机、电脑和电视等）和浏览器上收集和存储您的软件信息、硬件信息、您主动上传至本网站服务器的信息及您使用偏好信息，上述信息包括但不限于您手机IMEI号，用户名，操作系统信息，您的 IP 地址，Cookie信息，GPS等位置服务使用情况，您所访问的页面等信息，但不包含任何与您业务相关的数据。",
    "info6_3": "3、您同意遵守您所在地适用的有关您产品终端用户数据收集和保护的法律和行业标准，并确保您使用我们的服务完全合乎该等法律及行业标准的规定。作为第四范式智能客服服务的使用者，您必须制定、发布您的隐私政策并由您产品终端用户接受。该政策应不低于第四范式智能客服云服务的隐私保护标准，特别是：",
    "notice1": "(i) 告知您有第三方合作伙伴（即第四范式）以及采用一定的技术手段收集、存储、处理和使用您的产品终端使用的数据，并说明该行为的必要性；",
    "notice2": "(ii) 不向未成年人收集个人数据信息，如果您是面向未成年人的应用开发者，应保证该应用的使用在成年人的监护下进行。",
    "notice3": "我们将采用业内通行的，合理的标准来保护我们所收集的数据的安全性和保密性。",
    "info6_4": "4、我们会严格遵守《中华人民共和国网络安全法》中涉及的各项隐私保护条款。",
    "property": "知识产权",
    "info7_1": "1、本服务由第四范式（北京）技术有限公司研发。本服务的一切版权，以及与第四范式智能客服相关的所有信息内容，包括但不限于著作、图片、档案、资讯、资料、架构、页面设计，均由本公司依法拥有其知识产权。",
    "info7_2": "2、除第四范式或第三方明示同意外，您无权复制、传播、转让、许可或提供他人使用上述资源，否则必须承担相应的责任。",
    "info7_3": "3、第四范式尊重他人的知识产权。如果您认为相应信息对您的作品的使用已经构成版权侵犯，请通过公布于第四范式的客服电话及时通知我们，我们将按照现行法律法规的规定的版权侵权投诉程序予以处理。",
    "free": "免责申明",
    "condition": "如发生下述情形，本网站及第四范式不承担任何法律责任：",
    "info8_1": "1、依据法律规定或相关政府部门的要求提供您的个人信息；",
    "info8_2": "2、由于您的使用不当而导致任何个人信息的泄露；",
    "info8_3": "3、任何由于黑客攻击，电脑病毒的侵入，非法内容信息、骚扰信息的屏蔽，政府管制以及其他任何网络、技术、通信线路、信息安全管理措施等原因造成的服务中断、受阻等不能满足用户要求的情形；",
    "info8_4": "4、用户因第三方如运营商的通讯线路故障、技术问题、网络、电脑故障、系统不稳定及其他因不可抗力造成的损失的情形；",
    "info8_5": "5、使用本服务可能存在的来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息而招致的风险；",
    "info8_6": "6、第四范式不对用户信息的保存、修改、删除或储存失败负责。对网站上的非因第四范式故意所导致的排字错误、疏忽等不承担责任。",
    "other": "其他条款",
    "info9_1": "1、如果本条款中任何一条被视为废止、无效或因任何理由不可执行，该使用条件应视为可分割的且不影响任何其余条款的有效性和可执行性。",
    "info9_2": "2、本服务协议的解释、效力及纠纷的解决，适用于中华人民共和国法律。若您和我们之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，您同意将纠纷或争议提交第四范式（北京）技术有限公司所在地有管辖权的法院诉讼解决。",
    "info10_1": "如果您对本服务条款有任何问题或建议或有其他事情需要联系我们，请发邮件至"
  },
  "worklist_data": {
    "WB_WEB": "Chatroom_Web",
    "WB_APP": "Chatroom_App",
    "WB_WECHAT": "Chatroom_Wechat",
    "LM_WEB": "Leaving Message_Web",
    "LM_APP": "Leaving Message_App",
    "LM_WECHAT": "Leaving Message_Wechat",
    "OTHER": "Other",
    "delted": "Deleted"
  },
  "index": {
    "product": "Product introduction",
    "resolve": "Solution",
    "guide": "User guide",
    "efficient": "Customer service efficiency improving",
    "cost_save": "Annual cost savings",
    "transfer": "Transformation improving",
    "four_advan": "Four big advantages",
    "all_channel": "Connect with all channels in a short time"
  },
  "pay": {
    "version": "Your current version",
    "no_function": "Such function is not available, and you can contact the business engineer to upgrade into professional edition to unlock 10,000 rules and all system functions to enjoy premium value"
  },
  "contact_bussiness": {
    "business": "Business cooperation Tel18501331225 (Same as Wechat number)",
    "operating": "Product operation Tel18501331225 (Same as Wechat number)"
  },
  "foot": {
    "name": "XiaoShi robot",
    "title": "To make every enterprise have their own dialogue robot",
    "net": "Put on record in Beijing Computer Information Network and Internet Security Unit",
    "company_empty": "Please enter the company or team name",
    "submit_succ": "Submit successfully, we will contact you as soon as possible!",
    "make_show": "Make an appointment to demonstrate"
  },
  "nav": {
    "index": "Home page",
    "product": "Product",
    "phone": "Telephone robot",
    "partner": "Business cooperation",
    "agent": "Agent joining",
    "business": "Contact the business",
    "kefu_guide": "Intelligent customer service guide",
    "phone_guide": "Telephone robot guide",
    "down": "Download APP",
    "to_system": "Enter the management backstage"
  },
  "agent": {
    "title": "Work together with partners to create new future",
    "sub1": "Invite cooperative partners to join in",
    "sub2": "Promote, distribute and sell the series products of 4Paradigm robot to share the market with hundred billions of profits",
    "apply": "Apply to join",
    "person": "Contact person",
    "tel": "Contact information",
    "apply_succ": "Apply successfully, we will contact you as soon as possible!",
    "person_empty": "Please enter the contact person",
    "tel_empty": "Please enter the contact information"
  },
  "down_app": {
    "title": "Client side of XiaoShi intelligent customer service",
    "sub": "We are the best option and reliance for thousands of clients",
    "iphone": "iPhone download",
    "android": "Android download",
    "content_show": "Display content"
  },
  "evaluation": {
    "customer": "Customer service statistics",
    "star": "Star level",
    "customer_total": "Customer service summarizing",
    "cvs_count_all": "Total number of reception sessions",
    "visitor_count_all": "Total number of reception visitors",
    "customer_detail": "Customer service details",
    "treat_num": "Maximum reception number",
    "cvs_count": "Number of reception sessions",
    "visitor_count": "Number of reception visitors",
    "customer_star": "Customer service score",
    "star_count": "(Person) evaluation",
    "star_num": "Star",
    "no_eva": "No evaluation at present",
    "five_star": "5 stars",
    "four_star": "4 stars",
    "three_star": "3 stars",
    "two_star": "2 stars",
    "one_star": "1 stars",
    "count": "Number of",
    "star_distribute": "Star level distribution",
    "tag_distribute": "Label distribution",
    "tag_name": "Label name"
  },
  "问答库": "Q&A pack",
  "点击行业问答库": "Click industry Q&A pack",
  "行业问答库": "Industry Q&A pack",
  "批量或单个添加": "Batch or single addition",
  "机器人根据": "Robot according to",
  "进行回复。": "To reply",
  "导入策略（当有任一以下情况发生时，则该问题将不会被导入）：": "Lead - in strategy(If any of the following circumstances occurs, the question will not be led in ):",
  "1、问答包中的问题在业务问答中已经存在；": "1. The question in Q&A pack has existed in the service Q&A",
  "2、问答包中问题的是现有业务问答中某个问题的相似问题。": "2. The question in Q&A pack is similar to a certain question in the existing service Q&A",
  "分类": "Classification",
  "默认分类": "Default category",
  "批量操作": "Batch operate",
  "导入": "import",
  "导出": "export",
  "添加": "add",
  "问答": "Q&A",
  "已选择": "Already selected",
  "条": " (Number of information)",
  "批量删除": "Batch delete",
  "批量启用": "Start to use in batch",
  "批量停用": "Stop to use in batch",
  "清空": "Clear",
  "业务问答": "Service Q&A",
  "请添加": "Please add",
  "还没有": "Not yet",
  "有用/无用（有用率）": "Useful / useless (effective rate)",
  "匹配模式": "Match pattern",
  "导入问答": "导入问答",
  "1、请按照模板格式准备需要导入的数据": "1. Please prepare the data which needs to be led-in according to template format",
  "问答模版": "Q&A template",
  " 2、请选择需要导入的文件": "2. Please select the file need to import",
  "上传文件": "Upload file",
  "注意：": "Attention：",
  "1、所有相似问题不能重复": "1. All similar questions cannot be repeated",
  "2、文件中标准问题不能重复": "2. The standard questions in documents can’t be repeated",
  "3、当文件与系统中标准问题重复，相似问题被融合，答案被覆盖": "3. When the standard questions repeat in the system, the similar questions will be blended, and the answer will be covered",
  "重新上传": "Upload again",
  "原因如下：": "Reasons as follows:",
  "不用了": "No need",
  "进入教程": "Enter the tutorial",
  "清空问答库": "Empty the Q&A pack",
  "导出问答": "Export the Q&A",
  "全部分类": "All classifications",
  "知识规则": "Knowledge rules",
  "进行回复": "To reply",
  "自定义词库": "User-defined word library",
  "批量导入": "Batch import",
  "全部导出": "Export all",
  "清空词库": "Clear up the word library",
  "添加企业内部术语，提高机器人回复准确率，比如专业术语，产品简称，部门代号等。": "Add company internal terms to improve the accuracy of robot response, such as professional terms, product abbreviations, department codes, etc",
  "词库名称": "Name of the word library",
  "词库名不能为空": "Name of the word library can’t be empty",
  "公司信息": "Company information",
  "公司名称": "Company name",
  "公司地址": "Company address",
  "公司邮箱": "Company E-mail",
  "公司电话": "Company phone",
  "公司联系人": "Company contact person",
  "联系人电话": "Phone number of the contact person",
  "版本信息": "Version information",
  "当前版本": "Current version",
  "升级": "Upgrade",
  "机器人数": "Number of the robots",
  "坐席个数": "Number of the seats",
  "问答规则": "Q&A rules",
  "个": "(Number of)",
  "次": "(How many times)",
  "年": "Year",
  "任务对话": "Task dialogue",
  "场景": "Scene",
  "到期时间": "Expiration time",
  "剩余": "Surplus",
  "天": "Day",
  "续费": "Fees for renewal",
  "消息条数": "The quantity of messages",
  "已开通无限消息包": "Unlimited message packet has been opened",
  "消息包": "Message pack",
  "共": "Total",
  "已使用": "Already used",
  "服务支持": "Service support",
  "申请服务": "Request service",
  "服务": "Service",
  "状态": "Status",
  "产品故障修复": "Product failure repair",
  "VIP技术咨询和技术指导": "VIP technical consultation and instruction",
  "产品使用咨询": "Consultation on product use",
  "问答库配置优化": "Consultation on product use",
  "任务对话配置和对接": "Configuration optimization of Q&A library",
  "机器人优化服务": "Optimization service of robot",
  "请输入公司名称": "Please enter the company name",
  "升级获取更多权限和功能及定制，请联系商务": "Please contact the business engineer for upgrading, which can help you to get access to more rights, function and customization",
  "公司账号": "Company account",
  "开通服务列表": "Create service list",
  "套餐版本": "Package version",
  "付费版": "Paid version",
  "免费版": "Free edition",
  "套餐余额": "Package balance",
  "当前套餐详情": "Current package details",
  "开通机器人列表": "Create robot list",
  "开通坐席列表": "Create seat list",
  "价格": "Price",
  "起始日期": "Start date",
  "终止日期": "Termination date",
  "设置机器人": "Set robot",
  "您的使用时长已到期，该机器人已关闭。请": "Your service time has been expired, and the robot has stopped work. Please",
  "立即续费": "Renew now",
  "该机器人已被系统禁用，停止工作！如需解禁，请": "This robot has been prohibited by the system and stopped work. If you want to continue to use, please",
  "联系运营人员": "Contact the operational staff",
  "添加机器人": "Add robot",
  "添加机器人，还可添加": "Add robots, you can also add",
  "您当前版本机器人总数为": "The total of your robot version is",
  "升级至": "Upgrade to",
  "请联系商务": "Please contact the commercial staff",
  "升级机器人总数至": "The total of upgrading robots is",
  "修改机器人名称": "Modify robot name",
  "修改机器人信息": "Modify robot information",
  "小式机器人": "XiaoShi robot",
  "让每一个企业都拥有自己的对话机器人": "To make every enterprise have their own dialogue robot",
  "您的账号没有登录权限": "Your account does not have login permission",
  "请勾选阅读并接受《第四范式智能客服云服务用户协议》": "Please check off “to read and accept the Cloud Service User Agreement of 4Paradigm Intelligent Customer Service”",
  "图形验证码": "Graph validate code",
  "添加问答": "Add Q&A",
  "您的账户已到期，相关功能已受限制，请及时续费": "Your account has expired and related functions have been restricted. Please renew in time",
  "（过期后自动降为基础版且仅保留第一个机器人）": "(After expiration, it will automatically degrade to the basic version and only the first robot will be kept.)",
  "您的消息数即将耗尽，为保证机器人的正常工作，请及时续费": "The total of your message is about to reach the upper limit. Please renew it in time to ensure the normal operation of the robot",
  "您的消息数已耗尽，机器人已停止工作，请及时续费": "Your total message has reached the upper limit and the robot has stopped working. Please renew it in time",
  "请输入手机号": "Please enter the mobile number",
  "请输入公司或团队名称": "Please enter the company or team name",
  "请输入使用场景描述": "Please enter the usage scenario description",
  "请输入正确的手机号": "Please enter the correct mobile number",
  "使用场景描述": "Usage scenario description",
  "请填写真实信息，虚假信息无法保证正常使用，我们会定期清理虚假信息账号": "Please fill in the real information, for false information can’t guarantee the normal use, and we will regularly clean up the false information account",
  "亲爱的主人, 请完善你的信息": "Dear host, please complete your information :",
  "提示": "Hint:",
  "周老师": "Mr. Zhou",
  "微信手机同号": "Mobile phone number same as Wechat number",
  "商务合作": "Business cooperation",
  "微信同号": "Same as Wechat number",
  "运营": "Operation",
  "第四范式智能客服平台": "4Paradigm Intelligent customer service platform",
  "词典名称": "Dictionary name",
  "词典名称不能为空": "Dictionary name cannot be empty",
  "词典内的所有值，如：": "All the words in the dictionary, such as:",
  "【老师姓名】词典对应的同类词为：王林老师，王林，李静老师，李景": "The same word in [teacher name] dictionary areTeacher Wang Lin, Wang Lin, Teacher Li Jing, Li Jing",
  "词汇": "Vocabulary",
  "添加词汇": "Add vocabulary",
  "编辑词典成功": "Edit dictionary successfully",
  "新建词典成功": "Newly create dictionary successfully",
  "接口名称": "Interface name",
  "请输入名称": "Please enter the name",
  "请求地址": "Request (URL) address",
  "请输入请求地址": "Please enter the request (URL) address",
  "请求类型": "Request type",
  "请输入请求类型": "Please enter the request type",
  "输入参数": "Input parameter",
  "名称": "Name",
  "参数": "Parameter",
  "默认值": "Default value",
  "操作": "Operate",
  "请输入请求名称": "Please enter the request name",
  "请输入请求参数": "Please enter the request parameter",
  "输出参数": "Output parameter",
  "如输出参数为": "If the output parameter is",
  "取值方式": "Dereferencing mode",
  "取值": "Dereferencing",
  "参数路径格式": "Parameter path format",
  "参数路径": 'Parameter path',
  "今日天气": "Todays weather",
  "09-20的天气": "Weather of September 20th",
  "请输入请求参数路径": "Please enter the request parameter path",
  "输出参数名称不能重复": "Output parameter name cannot be duplicate",
  "请求参数不能重复": "Request parameter cannot be duplicate",
  "编辑成功": "Edit successfully",
  "搜索任务": "Search task",
  "添加任务": "Add task",
  "暂时没有任务，请先": "No tasks at present. Please firstly",
  "任务名称": "Task name",
  "触发问题": "Trigger question",
  "启用/停用": "Start to use / Stop to use",
  "重命名": "Rename",
  "任务名": "Task name",
  "任务名不能为空": "Task name cannot be empty",
  "请输入任务名": "Please enter the task name",
  "的任务对话上限为10条，联系商务升级专业版，解锁十万条规则+多租户管理+无限会话包+无限任务对话+更多服务": "The maximum number of task-oriented conversation in...is 10. You can contact the business engineer to upgrade into professional edition to unlock 100,000 rules + multi-tenant management + unlimited conversation packages + unlimited task-oriented dialogues + more services",
  "任务名称修改成功": "Modify task name successfully",
  "新建任务成功": "Newly create task successfully",
  "确定要删除意图": "Do you want to delete the intention?",
  "删除意图": "Delete the intention",
  "成功": "Success",
  "启用": "Start to use",
  "停用": "Stop to sue",
  "您需要设置触发问题和机器人回复后，该任务才能启用?": "This task can be enabled after you set a trigger question and a robot reply?",
  "去设置": "Go to-settings",
  "添加接口": "Add interface",
  "暂时没有接口，请先": "No interface at present, please firstly:",
  "类型": "Type",
  "编辑接口": "Edit interface",
  "该接口正在被任务使用，无法进行编辑和修改": "This interface is being used by a task, and can’t be edited or modified",
  "确定要删除接口": "Confirm to delete interface",
  "删除成功": "Delete successfully",
  "视频教程": "Video tutorial",
  "任务列表": "Task list",
  "参数词典": "Parameter dictionary",
  "接口管理": "Interface management",
  "访客关于此问题的常用表达，配置时需尽可能多的覆盖用户的不同问法方式。": "As for visitors common expressions on this question, you need to cover as many different ways of questioning as possible when configuring",
  "如访客想获取老师的联系方式，那么可以设置如下触发问法：": "If the visitor wants to get the teacher's contact information, they can set the trigger questions as follows:",
  "触发问法1:老师的联系方式是多少？": "Trigger question 1What is the teachers contact information?",
  "触发问法2:老师的手机号是多少？": "Trigger question 2What is the teachers mobile phone number?",
  "触发问法3:如何联系老师": "Trigger Question 3How to Contact the Teacher",
  "支持划词：所划词语为回答该问题所必须的任务参数。": "Support word underlinethe word underlined must be the necessary task parameters for answering the question",
  "如：询问老师的联系方式的任务中，机器人需获取用户语言中的【老师姓名】作为参数去词典里匹配，则可将老师二字设为任务参数。": "For example, in the task of asking the teacher's contact information, the robot needs to obtain the [teacher's name] in the user's language as a parameter to match in the dictionary, then the word “teacher” can be set as the task parameter",
  "请划词标识槽位，提高匹配匹配概率": "Please underline word to mark the slot to improve the matching probability",
  "添加问题": "Add question",
  "任务参数": "Task parameter",
  "回答该问题需向用户索要的参数信息。": "To answer this question, please ask the user for the parameter information",
  "在询问老师联系方式的任务中，机器人需获取用户语言中的【老师姓名】作为任务参数": "In the task of asking the teachers contact information, the robot needs to obtain [teacher name] in the user language as the task parameter",
  "参数名称": "Parameter name",
  "任务参数的所有可能取值集合，机器人从用户回答中提取信息后将在参数词典里匹配。我们已经为您预置好一些常用词典，如：日期，人名，地址等，您也可以自定义词典。": "For the collections of all possible values in the task parameters, the robot will extract information from the user's response and then match in the parameter dictionary. We have preset some common dictionaries for you, such asdate, name, address, etc. You can also customize the dictionary",
  "在获取老师联系方式的对话中，任务参数老师姓名 对应【老师姓名】词典，该词典中需包含所有来时的姓名": "In the dialogue for obtaining the teachers contact information, the task parameter “teacher name” corresponds to the [teacher name] dictionary, and the dictionary needs to include all the names from the time of arrival",
  "追问问题": "Asking questions further",
  "追问次数": "Questioning times",
  "添加任务参数": "Add task parameter",
  "机器人回答": "Robot reply",
  "当用户发问且命中答案后，配置的机器人回复。": "When the user asks a question and hits the answer, the configured robot responds",
  "您可以将对应的任务参数或接口返回值添加到机器人回复，设置多种回复方式可以让机器人显得更任性哦！": "You can add the corresponding task parameters or interface return value to the robot response. Setting multiple response methods can make the robot become more willful!",
  "机器人必须设置回复后此问答才会生效": "This question and answer will not take effect until the robot has set a reply",
  "直接回答": "Directly answer",
  "接口回复": "Interface reply",
  "回复类型": "Reply type",
  "接口列表": "Interface list",
  "暂无数据": "No data at present",
  "新增接口": "Newly increased interface",
  "接口配置": "Interface configuration",
  "接口返回": "Interface return",
  "添加机器人回答": "Add robot reply",
  "暂无机器人回答": "No robot reply at present",
  "保存中": "Saving",
  "参数KEY": "Parameter key :",
  "对应任务参数": "Corresponding task parameters",
  "该接口没有需要配置的输入参数": "There are no input parameters to be configured for this interface",
  "编辑参数": "Edit parameter",
  "新增参数": "Newly increased parameter",
  "请输入参数名称": "Please enter the parameter name",
  "在获取老师联系方式的对话中，任务参数老师姓名 对应【老师姓名】词典，该词典中需包含所有老师的姓名": "In the dialogue for obtaining teacher contact information, the task parameter “teacher name” corresponds to the [teacher name] dictionary, and the dictionary must include the names of all teachers",
  "请选择参数词典": "Please select the parameter dictionary",
  "请输入追问问题": "Please enter a follow-up question",
  "新增词典": "Newly increased dictionary",
  "加载中": "In the loading",
  "参数名称不能重复": "Parameter name cannot be duplicate",
  "机器人回复不能为空": "Robot reply cannot be empty",
  "触发问题不能为空": "Trigger question cannot be empty",
  "任务编辑成功": "Edit task successfully",
  "词典搜索": "Dictionary searching",
  "添加词典": "Add dictionary",
  "暂时没有词典，请先": "No dictionary at present, please firstly",
  "编辑词典": "Edit dictionary",
  "该词典正在被任务使用无法删除": "The dictionary is in use by a task and can’t be deleted",
  "确定要删除词典": "Confirm to delete the dictionary",
  "有用/无用（有用率)": "Useful / useless (effective rate)",
  "请输入搜索内容": "Please enter the search content",
  "最多选择": "The most choices",
  "个好友": "(Number of) friends",
  "放大": "Zoom in",
  "缩小": "Zoom out",
  "像左旋转": "Rotate left",
  "向右旋转": "Rotate right",
  "重新裁剪": "Re clipping",
  "图片类型必须是.gif,jpeg,jpg,png,bmp中的一种": "Picture type must be one of the GIF, JPEG, JPG, PNG, BMP type",
  "机器人头像": "Robot head portrait",
  "自定义": "User-defined",
  "恢复默认": "Restore default",
  "机器人昵称": "Robot nickname",
  "修改": "Modify",
  "恢复默认头像成功": "Restore default head portrait successfully",
  "请选择图片文件": "Please select the picture file",
  "只支持以下格式文件": "Only the files with the following format are supported",
  "图片大小限制": "Picture size limited",
  "修改头像成功": "Modify head portrait successfully",
  "进入账号详情页": "Enter the details page of the account",
  "智能客服": "Intelligent customer service",
  "人工客服": "Staff service",
  "工单中心": "Work order center",
  "账号详情": "Account details",
  "选择图文消息的发送方式": "Select the way to send text messages",
  "图文卡片形式": "Graphic card format",
  "编辑的图文答案以消息卡片的形式发送给访客，访客点击后跳转到新页面查看内容": "The edited graphic answer is sent to the visitor in the form of a message card. The visitor clicks it to jump to a new page to view the content",
  "富文本形式": "Rich text form (rtf)",
  "链接形式": "Link form",
  "编辑的图文答案以页面链接直接发送给访客": "Edited graphic answers are sent directly to visitors through page links",
  "图片裁剪": "Picture clipping",
  "上传失败": "Upload failed",
  "注意": "Attention",
  "1. 当文档中某一行的标准问题或答案为空时，该行将不会被导入到问答库中": "1. When the standard question or answer of a line in the document is empty, this line will not be led into the Q&A library",
  "2. 当文档中某一标准问题与问答库中的标准问题完全一致时，它的相似问题会添加至问答库中，它的答案会覆盖原答案": "2. When a standard question in the document is completely consistent with the standard question in the Q&A library, its similar questions will be added to the Q&A library, and its answer will cover the original answer",
  "1. 文档中的标准问题或相似问题字数超过80，或答案字数超过2000": "1. Standard or similar questions in a document have more than 80 words, or their answers have more than 2000 words",
  "2. 文档中的相似问题与文档或知识库中的标准问题完全一致": "2. Similar questions in the document are exactly the same as standard questions in the document or knowledge base",
  "3. 文档中的标准问题有重复": "3. Standard questions in the document has repeated",
  "导入成功": "Import successfully",
  "搜索": "Search",
  "上传结果": "Upload result",
  "成功上传": "Upload successfully",
  "个文件": "(Number of) files",
  "共上传": "Total upload",
  "失败上传": "Upload failed",
  "失败原因": "Failure reason",
  "菜单名称": "Menu name",
  "子菜单": "Submenu",
  "答案": "Answer",
  "文本": "Text",
  "切换": "Switch to",
  "对接渠道": "Docking channel",
  "点击": "Click",
  "机器人测试": "Robot test",
  "关闭机器人测试": "Close robot test",
  "知识管理": "Knowledge management",
  "基础设置": "Basic setting",
  "技能管理": "Skill management",
  "访客端设置": "Guest side setting",
  "转人工设置": "Transfer to staff service setting",
  "接入渠道": "Connection to channels",
  "网站": "Website",
  "手机APP": "Mobile APP",
  "微信公众号": "WeChat public account",
  "微信小程序": "Wechat applet",
  "企业微信": "Enterprise Wechat",
  "个人微信": "Personal Wechat",
  "微博": "Weibo",
  "访客统计": "Visitor statistics",
  "问答统计": "Q&A statistics",
  "客服统计": "Customer service statistics",
  "级分类": "Level classification",
  "提交成功": "Submit successfully",
  "平台版": "Platform version",
  "运营管理后台": "Operation management background system",
  "商务后台": "Business backstage",
  "请输入图文内容": "Please enter the image-text content",
  "请选择图文": "Please select the image-text",
  "素材库": "Material library",
  "请输入正确图片地址": "Please enter the correct picture address",
  "高校智能客服": "College intelligent customer service",
  "帮您自动准确解答95%的问题，剩下5%疑问人工回答！": "95% of the questions will be answered automatically and accurately and the remaining 5% of the questions will be answered by staff service",
  "应用了人工智能的自然语言识别处理、大数据、云计算等技术，": "Natural language recognition processing, big data, cloud computing and other technologies of artificial intelligence are applied",
  "为学校业务部门建立统一管理的在线智能咨询服务平台": "Establish online consulting service platform with unified management for school business department",
  "产品负责人： 周老师 18310505996（手机、微信）": "Person in charge of the productMr. Zhou 18310505996 (Mobile phone and Wechat number)",
  "赛尔超星 高校智能客服": "Cerstar college intelligent customer service",
  "微信扫码关注高校智能客服周老师": "Scan Wechat code and follow college intelligent customer service Mr. Zhou",
  "功能使用与技能支持": "Function usage and skill support",
  "了解更多功能细节或购买高校智能客服产品，请您联系": "In order to know more function details or purchase college intelligent customer service product, please contact",
  "机器人问答统计": "Robot Q&A statistics",
  "人工客服问答统计": "Staff service Q&A statistics",
  "第三方应用对接": "Third party application docking",
  "高校智能教学助手": "College intelligent teaching assistant",
  "产品负责人": "Person in charge of the product",
  "微信扫码关注高校智能教学助手周老师": "Scan Wechat code and follow college intelligent teaching assistant Mr. Zhou",
  "了解更多功能细节或购买高校智能教学助手，请您联系": "In order to know more function details or purchase college intelligent teaching assistant product, please contact",
  "助教老师": "Teaching assistant teacher",
  "知识库": "Knowledge base",
  "知识问答": "Knowledge Q&A",
  "知识点": "Knowledge point",
  "该页面存在未保存的修改, 是否坚持离开": "The changes on this page is unsaved. Do you want to leave now?",
  '机器人回复用户任务结果或信息。': '机器人回复用户任务结果或信息。',
  '您可以选择直接回复让机器人统一回复指定对内容，也可以将对应的任务参数或接口返回值添加到机器人回复，并通过API实现更多逻辑处理。': '您可以选择直接回复让机器人统一回复指定对内容，也可以将对应的任务参数或接口返回值添加到机器人回复，并通过API实现更多逻辑处理。',
  '另外，设置多种回复方式可以让机器人显得更任性哦！': '另外，设置多种回复方式可以让机器人显得更任性哦！',
  '确认': 'Confirm'
}




// WEBPACK FOOTER //
// ./src/common/lang/en.js